<template lang="html">
<div>
    <h3 align="left">
        <vlt-icon :icon="demoType.icon" color="black" />
        {{t(demoType.description)}}
    </h3>
    <div class="Vlt-grid" v-if="demoItems && demoItems.length">
        <div class="Vlt-col" v-for="demoItem in demoItems">
            <div class="Vlt-gradient--pink-to-peach">
                <div class="Vlt-card Vlt-card--plain" @click="launchDemo(demoItem)">
                    <vlt-icon v-if="icontype" :icon="icontype" color="indigo" class="Vlt-icon--large" />
                    <div class="Vlt-card__content">
                        <h3 class="Vlt-title--margin-top4">{{t(demoItem.name)}}</h3>
                        <b>{{t(demoItem.description)}}</b>
                        <br />
                        <button class="Vlt-btn Vlt-btn--no-focus Vlt-btn--app Vlt-btn--link Vlt-btn--large" style="margin: 16px 0 0 5px; min-height: 20px;" :disabled="!demoItem.active || (!demoItem.url && !demoItem.component)" @click="launchDemo(demoItem,demoItems)">
                            <vlt-icon icon="arrow-thin-right" :color="demoItem.active || (demoItem.url && demoItem.component) ? 'black' : 'grey'" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <vlt-button :label="t('Clear Demo')" secondary app @click="clear" />
</div>
</template>

<script lang="js">
import nidsDemoItem from "./nidsDemoItem";

import {
    $HTTP
} from '../services/nidsInternal.js';
import {
    VltIcon,
    VltButton,
} from "@vonagevolta/vue";
export default {
    name: 'nidsDemos',
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoType: {
            type: Object,
            default: function () {
                return {
                    type: "feature",
                    icon: "rocket",
                    desc: "Individual Feature Demos",
                }
            },
            required: false,
        },
        baselang1: {
            type: Object,
            required: false
        },
        lang1: {
            type: Object,
            required: false
        }
    },
    mounted() {

    },
    data() {
        return {
            isLoading: false,
            demoItems: [],
            icontype: 'rocket',
            required: false
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        clear() {
            delete localStorage.han;
            delete localStorage.conId;
            this.$swal('Demo Reset Confirmed!',
                'Demo has been reset',
                'success');
        },
        async fetch() {
            this.isLoading = true
            console.log("Loading Campus Demos...");
            const {
                data
            } = await $HTTP.get('demos/' + this.demoType.type);
            this.isLoading = false;
            this.demoItems = data;
        },
        launchDemo(data) {
            data.demos = this.demoItems;
            this.$emit("launchDemo", data);
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang1, this.baselang1)
        },
    },
    computed: {

    },
    components: {
        nidsDemoItem,
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
    }
}
</script>

<style lang="scss" scoped>
.Vlt-card {
    cursor: pointer;
    height: 100%;
    border-bottom-right-radius: 18px;
}

.Vlt-gradient--pink-to-peach {
    border-radius: 18px;
    height: calc(100% - 24px);
    padding-right: 6px;
    padding-bottom: 6px;
}
</style>
